export default from './Tabs';

export TabPane from './TabPane';



// WEBPACK FOOTER //
// ./_rc-tabs-5.9.2/src/index.js